import type { VoteEntity } from "@/appInterface/windows/VoteWindow/VoteResults/types";
import {
    AI_MENU_BUTTON_ANIMATION_CLASS,
    AI_MENU_BUTTON_CLASS,
    AI_MENU_BUTTON_SVG_CLASS,
} from "@/widgetMenu/wm_aiAssistant";
import type { PropertyBuildMessage, PropertyUpdateMessage } from "./types";

export const addVote = (
    childUID: string,
    property: PropertyBuildMessage["property"],
    activeVote: VoteEntity,
) => {
    Object.values(activeVote.children).forEach((child) => {
        if (child.widgetData?.UID === childUID) {
            child.votes.push({
                token: property.token,
                accountName: property.accountName || "",
            });
        }
    });
};
export const removeVote = (childUID: string, token: string, activeVote: VoteEntity) => {
    for (const child of Object.values(activeVote.children)) {
        if (child.widgetData?.UID === childUID) {
            const idx = child.votes.findIndex((v) => v.token === token);
            if (idx >= 0) {
                child.votes.splice(idx, 1);
                break;
            }
        }
    }
};

export const handlePropertyUpdate = (msg: PropertyUpdateMessage, activeVote: VoteEntity) => {
    if (msg.state.additionalDuration) {
        activeVote.duration += msg.state.additionalDuration;
    }
    if (msg.state.isResolved) {
        activeVote.isResolved = true;
    }
};

export const handlePropertyBuild = (msg: PropertyBuildMessage, activeVote: VoteEntity) => {
    if (msg.action === "add") {
        addVote(msg.property.childUID, msg.property, activeVote);
    } else if (msg.action === "remove") {
        removeVote(msg.property.childUID, msg.property.token, activeVote);
    }
};

export const enableAiButton = () => {
    const button: HTMLButtonElement | null = document.querySelector(`.${AI_MENU_BUTTON_CLASS}`);
    const buttonSvg: SVGSVGElement | null = document.querySelector(`.${AI_MENU_BUTTON_SVG_CLASS}`);
    const animationWrapper: HTMLDivElement | null = document.querySelector(
        `.${AI_MENU_BUTTON_ANIMATION_CLASS}`,
    );

    if (button && buttonSvg && animationWrapper) {
        button.disabled = false;
        buttonSvg.style.display = "block";
        animationWrapper.style.display = "none";
    }
};
